import React, { CSSProperties } from 'react';
type OrnamentProps = {
  className?: string;
  color?: string;
  style?: CSSProperties;
};
export function FlowerOfLife({
  className = '',
  color = '#6E4E96',
  style
}: OrnamentProps) {
  const centers: [number, number][] = [[50, 50], [64, 50], [57, 37.9], [43, 37.9], [36, 50], [43, 62.1], [57, 62.1]];
  return <svg viewBox="0 0 100 100" className={className} style={style} fill="none" stroke={color} strokeWidth="0.9" aria-hidden="true" data-id="element-122" data-mp="39vkaat8a95n0">
      {centers.map(([cx, cy]) => <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="14" data-id="element-123" data-mp="2m8lzab2xmpwh" />)}
      <circle cx="50" cy="50" r="28" data-id="element-124" data-mp="2m6995an0t98c" />
      <circle cx="50" cy="50" r="42" data-id="element-125" data-mp="2qzlyjmzixk25" />
    </svg>;
}
export function MetatronCube({
  className = '',
  color = '#C69A4C',
  style
}: OrnamentProps) {
  const vertices: [number, number][] = [[50, 12], [83, 31], [83, 69], [50, 88], [17, 69], [17, 31]];
  return <svg viewBox="0 0 100 100" className={className} style={style} fill="none" stroke={color} strokeWidth="0.9" strokeLinejoin="round" aria-hidden="true" data-id="element-126" data-mp="35xzzymyu75do">
      <circle cx="50" cy="50" r="44" data-id="element-127" data-mp="2x4d837xr2m9r" />
      <polygon points={vertices.map(([x, y]) => `${x},${y}`).join(' ')} data-id="element-128" data-mp="2x3bw918wtvqz" />
      <polygon points="50,12 83,69 17,69" data-id="element-129" data-mp="2s50ocw26dvbe" />
      <polygon points="50,88 17,31 83,31" data-id="element-130" data-mp="2s491c9mn95wq" />
      {vertices.map(([x, y], index) => <line key={`${x}-${y}`} x1={x} y1={y} x2={vertices[(index + 3) % 6][0]} y2={vertices[(index + 3) % 6][1]} data-id="element-131" data-mp="2n8a4dxn92fkp" data-mpi={index} />)}
      {[...vertices, [50, 50] as [number, number]].map(([cx, cy]) => <circle key={`c-${cx}-${cy}`} cx={cx} cy={cy} r="4.5" data-id="element-132" data-mp="2e6kg30onzwr5" />)}
    </svg>;
}
export function Merkaba({
  className = '',
  color = '#2F7D80',
  style
}: OrnamentProps) {
  return <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.2" strokeLinejoin="round" aria-hidden="true" data-id="element-133" data-mp="ce61oblbxafh">
      <polygon points="12,2.5 21.5,18 2.5,18" data-id="element-134" data-mp="qj68trwpb0xi" />
      <polygon points="12,21.5 2.5,6 21.5,6" data-id="element-135" data-mp="vbpmeove1w2b" />
      <circle cx="12" cy="12" r="10.4" strokeWidth="0.8" data-id="element-136" data-mp="vchalemnorik" />
    </svg>;
}
export function VesicaLeaf({
  className = '',
  color = '#2F7D80',
  style
}: OrnamentProps) {
  return <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.2" strokeLinecap="round" aria-hidden="true" data-id="element-137" data-mp="mje09f7b4us5">
      <circle cx="9" cy="12" r="7" data-id="element-138" data-mp="1e9iip8bib7qq" />
      <circle cx="15" cy="12" r="7" data-id="element-139" data-mp="10a9buz96xpzf" />
      <path d="M12 5.4v13.2" data-id="element-140" data-mp="1097qa0ujtl3g" />
    </svg>;
}
export function GoldenSpiral({
  className = '',
  color = '#C69A4C',
  style
}: OrnamentProps) {
  return <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.2" strokeLinecap="round" aria-hidden="true" data-id="element-141" data-mp="3l0hwjum9s9ps">
      <path d="M21 3v18H3V8.6h12.4v8.6h-5.3v-4.3h2.7" data-id="element-142" data-mp="3ig25c73zwq78" />
      <path d="M21 21C11 21 3 15 3 8.6" data-id="element-143" data-mp="3ieimc8qyg11r" />
    </svg>;
}